import React, { useEffect, useState } from "react";
import SingleQuestion from "./SingleQuestion";
import { connect } from "react-redux";
import {
  setFrontratingAnsweres,
  toggleAlphegaActiveState,
} from "../../redux/frontWebRating/actions";
import SingleAnswer from "./SingleAnswer";
import { useIntl } from "react-intl";
import {
  resolveCompanyId,
  getAlphigaFollowUpQuestions,
  getAlphigaFollowUpConfig,
  getAlphigaAllNoClearKeys,
  ALPHIGA_GATE_STATE_KEY,
} from "../../webRatingNew/constants/alphigaCompanies";

const ANSWER = {
  YES: "Yes",
  NO: "No",
};

function AlphegaQuestions(props) {
  const intl = useIntl();
  const [showAllQuestions, setShowAllQuestions] = useState(false);
  const [currentQueIndex, setCurrentQueIndex] = useState(1);
  const [triggerAnswer, setTriggerAnswer] = useState(null);
  const [displayAnswer, setDisplayAnswer] = useState({});

  const { setFrontratingAnsweres_, toggleAlphegaActiveState_, webRatingData } =
    props;

  const companyId = resolveCompanyId(webRatingData);
  const followUpConfig = getAlphigaFollowUpConfig(companyId);
  const followUpSectionIntroId = followUpConfig?.followUpSectionIntroId;
  const followUpQuestions = getAlphigaFollowUpQuestions(companyId);
  const totalFollowUps = followUpQuestions.length;

  const clearFollowUpAnswers = () => {
    getAlphigaAllNoClearKeys(companyId).forEach((key) => {
      setFrontratingAnsweres_({ key, value: "" });
    });
  };

  const answerQuestion = ({ key = null, value = null, queIndex }) => {
    if (
      !key ||
      !value ||
      ![ANSWER.YES, ANSWER.NO].includes(value) ||
      queIndex < 1 ||
      queIndex > totalFollowUps
    ) {
      return;
    }

    setFrontratingAnsweres_({ key, value });
    setDisplayAnswer((prev) => ({ ...prev, [queIndex]: value }));

    if (queIndex < totalFollowUps) {
      setCurrentQueIndex(Number(queIndex) + 1);
    } else {
      toggleAlphegaActiveState_(false);
    }
  };

  useEffect(() => {
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  }, [displayAnswer]);

  return (
    <>
      <SingleQuestion
        text={intl.formatMessage({
          id: "did-you-buy-medicine-in-the-pharmacy-today",
        })}
        onClickYes={() => {
          clearFollowUpAnswers();
          setFrontratingAnsweres_({
            key: ALPHIGA_GATE_STATE_KEY,
            value: ANSWER.YES,
          });
          if (totalFollowUps === 0) {
            setTriggerAnswer(ANSWER.YES);
            toggleAlphegaActiveState_(false);
            return;
          }
          setDisplayAnswer({});
          setCurrentQueIndex(1);
          setShowAllQuestions(true);
          setTriggerAnswer(ANSWER.YES);
        }}
        onClickNo={() => {
          clearFollowUpAnswers();
          setFrontratingAnsweres_({
            key: ALPHIGA_GATE_STATE_KEY,
            value: ANSWER.NO,
          });
          toggleAlphegaActiveState_(false);
          setTriggerAnswer(ANSWER.NO);
        }}
        onClickSkip={() => toggleAlphegaActiveState_(false)}
      />
      <SingleAnswer answer={triggerAnswer} />

      {showAllQuestions && followUpSectionIntroId ? (
        <SingleQuestion
          canAnswer={false}
          text={intl.formatMessage({ id: followUpSectionIntroId })}
        />
      ) : null}

      {followUpQuestions.map((q, idx) => {
        const queNum = idx + 1;
        return showAllQuestions && currentQueIndex >= queNum ? (
          <React.Fragment key={q.stateKey}>
            <SingleQuestion
              id={`scroll-${q.stateKey}`}
              text={intl.formatMessage({ id: q.messageId })}
              onClickYes={() =>
                answerQuestion({
                  key: q.stateKey,
                  value: ANSWER.YES,
                  queIndex: queNum,
                })
              }
              onClickNo={() =>
                answerQuestion({
                  key: q.stateKey,
                  value: ANSWER.NO,
                  queIndex: queNum,
                })
              }
              onClickSkip={() =>
                queNum < totalFollowUps
                  ? setCurrentQueIndex(queNum + 1)
                  : toggleAlphegaActiveState_(false)
              }
            />

            <SingleAnswer answer={displayAnswer[queNum]} />
          </React.Fragment>
        ) : null;
      })}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    alphegaActive: state.frontWebRatingDataReducer.alphegaActive,
    webRatingData: state.frontWebRatingDataReducer.webRatingData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFrontratingAnsweres_: (data) => dispatch(setFrontratingAnsweres(data)),
    toggleAlphegaActiveState_: (data) =>
      dispatch(toggleAlphegaActiveState(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AlphegaQuestions);
